// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"defs","attrs":{},"children":[{"tag":"mask","attrs":{"id":"props.overlapMaskId_fill1","maskUnits":"userSpaceOnUse","maskContentUnits":"userSpaceOnUse","mask-type":"luminance","x":"0","y":"0","width":"24","height":"24"},"children":[{"tag":"rect","attrs":{"x":"0","y":"0","width":"24","height":"24","fill":"#fff"}},{"tag":"path","attrs":{"stroke":"#000","d":"M18 1H14C11.2386 1 9 3.23858 9 6V9.5H5.25V14H9V23H14V14H17L18 9.5H14V6.5C14 5.94772 14.4477 5.5 15 5.5H18V1Z","strokeWidth":"props.strokeWidth","fill":"none"}}]}]},{"tag":"g","attrs":{"id":"logo-facebook"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M18 1H14C11.2386 1 9 3.23858 9 6V9.5H5.25V14H9V23H14V14H17L18 9.5H14V6.5C14 5.94772 14.4477 5.5 15 5.5H18V1Z","mask":"props.overlapMaskUrl_fill1"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M18 1H14C11.2386 1 9 3.23858 9 6V9.5H5.25V14H9V23H14V14H17L18 9.5H14V6.5C14 5.94772 14.4477 5.5 15 5.5H18V1Z","strokeWidth":"props.strokeWidth"}}]}]};

const LogoFacebookIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-facebook',
    ref,
    icon: element,
  },
));

LogoFacebookIcon.displayName = 'LogoFacebookIcon';

export default LogoFacebookIcon;
